import { createContext } from 'react';
import { Subject } from 'rxjs';
import { NotificationOptions } from './types';

// Main notification observable context
export const NotificationContext = createContext(new Subject<NotificationOptions>());

export const { Provider: NotificationProvider } = NotificationContext;
